// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__SiFzX","btn":"Footer_btn__uah3r"};